<template>
  <div class="search-page">
    <nav-bar />

    <section class="search-hero">
      <div class="hero-inner">
        <h1>保函真伪查询</h1>
        <p>输入保函编号，验证电子保函的真实性与有效性</p>
        <div class="search-box">
          <i class="el-icon-search"></i>
          <input
            v-model="keyword"
            placeholder="请输入保函编号，例如 GAT2024..."
            @keyup.enter.native="search"
          />
          <button class="g-btn g-btn-primary" @click="search">立即查询</button>
        </div>
      </div>
    </section>

    <section class="search-body g-container">
      <div v-if="!info.gatUrl" class="guide g-card">
        <h3>为什么要验证保函真伪？</h3>
        <div class="guide-grid">
          <div>
            <i class="ico ico-safe"></i>
            <div class="txt">
              <h4>防止假保函风险</h4>
              <p>不法分子伪造保函进行诈骗，验证可有效防范</p>
            </div>
          </div>
          <div>
            <i class="ico ico-paper"></i>
            <div class="txt">
              <h4>核对出函机构</h4>
              <p>验证保函出具机构是否为本平台合作机构</p>
            </div>
          </div>
          <div>
            <i class="ico ico-status"></i>
            <div class="txt">
              <h4>查证状态</h4>
              <p>实时查看保函是申请中、已出函还是已失效</p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="info.gatUrl" class="result g-card">
        <!-- 头部：公司名 + 已验证 -->
        <header class="result-head">
          <div class="company-block">
            <div class="company-badge" aria-hidden="true">
              <i class="el-icon-office-building"></i>
            </div>
            <div class="company-meta">
              <h3 class="company-name">{{ info.coName || '已验证保函' }}</h3>
              <div class="company-tags">
                <span class="tag tag-primary">{{ info.wayCode || '电子保函' }}</span>
                <span class="tag tag-success">
                  <span class="dot"></span>已通过真伪验证
                </span>
              </div>
            </div>
          </div>
          <a class="back-link" @click="reset">‹ 重新查询</a>
        </header>

        <!-- 核心数据：3列 -->
        <div class="core-stats">
          <div class="stat">
            <span class="stat-label">保证金金额</span>
            <span class="stat-value num">¥ {{ formatMoney(info.prjEarMoney) }}</span>
          </div>
          <div class="stat">
            <span class="stat-label">开标时间</span>
            <span class="stat-value">{{ info.tendStDate || '-' }}</span>
          </div>
          <div class="stat">
            <span class="stat-label">保证金截止</span>
            <span class="stat-value">{{ info.prjEndEarDate || '-' }}</span>
          </div>
        </div>

        <!-- 项目 + 保函编号 -->
        <div class="meta-row">
          <div class="meta-item">
            <span class="meta-label">项目名称</span>
            <span class="meta-value">{{ info.tendName }}</span>
          </div>
          <div class="meta-item">
            <span class="meta-label">保函编号</span>
            <span class="meta-value code">{{ info.gatNo }}</span>
          </div>
        </div>

        <!-- 底部：验证 + 联系（单条线） -->
        <footer class="result-foot">
          <span class="foot-status">
            <i class="el-icon-check"></i>电子保函真伪有效
          </span>
          <span class="foot-divider">·</span>
          <span class="foot-label">详询联系</span>
          <strong class="foot-phone">19179363419</strong>
          <span class="foot-tip">（蒋经理）</span>
        </footer>
      </div>

      <div v-else-if="hasSearched" class="g-empty">
        <img src="@/assets/noData.png" />
        <p>暂未查询到此保函编号</p>
        <p class="tip">请确认编号无误或联系客户经理：19179363419</p>
      </div>
    </section>

    <site-footer />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import SiteFooter from '@/components/SiteFooter'
import { getSearch, getSearchByToken } from '@/lib/api/index'
import { formatDate, formatMoney } from './usercenter/ucHelpers'

export default {
  name: 'Search',
  components: { NavBar, SiteFooter },
  data () {
    return {
      keyword: '',
      info: {},
      hasSearched: false
    }
  },
  created () {
    if (this.$route.query.id) {
      this.keyword = this.$route.query.id
      this.search()
    }
  },
  methods: {
    formatDate, formatMoney,
    search () {
      if (!this.keyword) return this.$message.warning('请输入保函编号')
      this.hasSearched = true
      const fn = localStorage.getItem('token') ? getSearchByToken : getSearch
      fn(this.keyword).then((res) => {
        if (res.code === 200) {
          if (res.data && res.data.type === '1') {
            this.info = res.data
          } else {
            this.info = {}
          }
        }
      })
    },
    reset () {
      this.info = {}
      this.hasSearched = false
      this.keyword = ''
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.search-page {
  min-height: 100vh;
  background: @bg-page;
}

.search-hero {
  background: linear-gradient(135deg, @primary 0%, #1E40AF 100%);
  color: #fff;
  padding: 80px 24px;

  .hero-inner {
    max-width: 720px;
    margin: 0 auto;
    text-align: center;
  }

  h1 {
    margin: 0 0 12px;
    font-size: 36px;
    font-weight: 700;
  }
  p {
    margin: 0 0 36px;
    color: rgba(255, 255, 255, .8);
    font-size: 15px;
  }
}

.search-box {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: @radius-full;
  padding: 6px 6px 6px 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, .12);
  gap: 12px;
  color: @text-strong;

  i { color: @text-muted; font-size: 18px; }

  input {
    flex: 1;
    border: none;
    outline: none;
    height: 44px;
    background: transparent;
    font-size: 15px;
    color: @text-strong;        /* 显式黑色，避免被父级白色继承 */
    caret-color: @primary;

    &::placeholder { color: @text-disabled; }

    &:focus { color: @text-strong; }
  }

  .g-btn {
    height: 44px;
    padding: 0 24px;
    border-radius: @radius-full;
  }
}

.search-body {
  padding: 48px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.guide {
  padding: 32px;

  h3 {
    margin: 0 0 24px;
    font-size: 20px;
    color: @text-strong;
  }
}

.guide-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  > div {
    text-align: center;

    .ico {
      width: 48px;
      height: 48px;
      background: @primary-soft;
      border-radius: @radius-md;
      margin: 0 auto 12px;
      display: block;
      position: relative;
      &::before {
        content: '';
        position: absolute;
        inset: 12px;
        background: @primary;
        border-radius: 6px;
      }
      &.ico-paper::before {
        mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='%23000' d='M14 2H6v20h12V8z M13 9V3.5L18.5 9z'/></svg>") center / contain no-repeat;
      }
      &.ico-safe::before {
        mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='%23000' d='M12 2l9 4v6c0 5-3.5 9-9 10-5.5-1-9-5-9-10V6z'/></svg>") center / contain no-repeat;
      }
      &.ico-status::before {
        mask: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path fill='%23000' d='M9 16l-4-4 1.4-1.4L9 13.2l8.6-8.6L19 6z'/></svg>") center / contain no-repeat;
      }
    }

    h4 {
      margin: 0 0 6px;
      font-size: 16px;
      color: @text-strong;
    }
    p {
      margin: 0;
      color: @text-muted;
      font-size: 13px;
      line-height: 1.6;
    }
  }
}



// ================== 已验证结果卡 ==================
.result {
  padding: 0;
}

.result-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 28px 28px 20px;
  border-bottom: 1px solid @border-light;

  .company-block {
    display: flex;
    align-items: center;
    gap: 14px;
    min-width: 0;
    flex: 1;
  }

  .company-badge {
    width: 48px;
    height: 48px;
    border-radius: @radius-md;
    background: @primary-soft;
    display: flex;
    align-items: center;
    justify-content: center;
    color: @primary;
    font-size: 22px;
    flex-shrink: 0;
  }

  .company-meta {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }

  .company-name {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: @text-strong;
    line-height: 1.3;
  }

  .company-tags {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;

    .tag {
      display: inline-flex;
      align-items: center;
      height: 22px;
      padding: 0 10px;
      border-radius: @radius-full;
      font-size: 12px;
      font-weight: 500;
      line-height: 1;
    }

    .tag-primary {
      background: @primary-soft;
      color: @primary;
    }

    .tag-success {
      background: @success-soft;
      color: @success;

      .dot {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: @success;
        margin-right: 6px;
        animation: pulseDot 1.5s infinite;
      }
    }
  }

  .back-link {
    color: @text-muted;
    font-size: 13px;
    cursor: pointer;
    transition: color @duration-fast @ease-out;
    white-space: nowrap;
    flex-shrink: 0;

    &:hover { color: @primary; }
  }
}

@keyframes pulseDot {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: .5; transform: scale(1.3); }
}

.core-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 24px 28px;
  background: linear-gradient(180deg, @bg-soft 0%, rgba(248, 250, 252, 0) 100%);
  border-bottom: 1px solid @border-light;

  .stat {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0 16px;
    border-right: 1px solid @border-light;

    &:first-child { padding-left: 0; }
    &:last-child { border-right: none; padding-right: 0; }

    .stat-label {
      color: @text-muted;
      font-size: 12px;
    }

    .stat-value {
      color: @text-strong;
      font-size: 18px;
      font-weight: 700;

      &.num {
        color: @danger;
        font-size: 24px;
      }
    }
  }
}

.meta-row {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
  padding: 20px 28px;
  border-bottom: 1px solid @border-light;

  .meta-item {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;

    .meta-label {
      color: @text-muted;
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: .5px;
    }

    .meta-value {
      color: @text-strong;
      font-size: 14px;
      font-weight: 500;
      word-break: break-all;

      &.code {
        font-family: 'SF Mono', Consolas, monospace;
        font-size: 13px;
        font-weight: 600;
      }
    }
  }
}

.result-foot {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 14px 28px;
  background: @success-soft;
  border-radius: 0 0 @radius-lg @radius-lg;
  font-size: 13px;
  color: @success;

  .foot-status {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-weight: 600;

    i { font-size: 14px; }
  }

  .foot-divider {
    color: rgba(16, 185, 129, .4);
  }

  .foot-label {
    color: @text-secondary;
    font-weight: 400;
  }

  .foot-phone {
    color: @text-strong;
    font-weight: 700;
    font-size: 14px;
    letter-spacing: .5px;
  }

  .foot-tip {
    color: @text-secondary;
    font-size: 12px;
  }
}

.g-empty {
  padding: 60px 20px;

  .tip {
    font-size: 12px;
    color: @text-disabled;
    margin-top: 4px;
  }
}

// ============ 移动端响应式 ============
@media (max-width: 768px) {
  .search-page { padding-bottom: 32px; }

  .search-hero {
    padding: 56px 16px 40px;

    .hero-inner { max-width: 100%; }

    h1 { font-size: 28px; }
    p { font-size: 14px; margin-bottom: 24px; }
  }

  .search-box {
    flex-direction: column;
    padding: 12px;
    border-radius: @radius-lg;
    align-items: stretch;
    gap: 10px;

    i { display: none; }

    input {
      height: 44px;
      padding: 0 4px;
      text-align: center;
      font-size: 14px;
    }

    .g-btn {
      width: 100%;
      border-radius: @radius-md;
    }
  }

  .search-body {
    padding: 24px 16px 32px;
    gap: 16px;
  }

  .guide {
    padding: 20px 18px;

    h3 { font-size: 17px; margin-bottom: 18px; }
  }

  .guide-grid {
    grid-template-columns: 1fr;
    gap: 16px;

    > div {
      display: flex;
      align-items: flex-start;
      text-align: left;
      gap: 14px;
      padding: 16px;
      background: @bg-soft;
      border-radius: @radius-md;

      .ico {
        flex-shrink: 0;
        margin: 0;
        width: 44px;
        height: 44px;
      }

      .txt { flex: 1; min-width: 0; }

      h4 {
        font-size: 15px;
        margin: 8px 0 6px;
      }
      p {
        font-size: 12px;
        line-height: 1.6;
        color: @text-secondary;
      }
    }
  }

  .result {
    padding: 20px 18px;

    .result-head h3 { font-size: 17px; }
  }

  .core-stats {
    grid-template-columns: 1fr;
    padding: 16px;

    .stat {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 12px 0;
      border-right: none;
      border-bottom: 1px dashed @border-light;

      &:last-child { border-bottom: none; }

      .stat-label { font-size: 13px; }
      .stat-value {
        font-size: 15px;
        &.num { font-size: 18px; }
      }
    }
  }

  .meta-row {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
  }

  .result-foot {
    padding: 12px 16px;
    font-size: 12px;
    gap: 6px;

    .foot-phone { font-size: 14px; }
  }

  .result-head {
    padding: 20px 18px 16px;
    flex-direction: column-reverse;
    align-items: stretch;

    .back-link { align-self: flex-end; }
    .company-name { font-size: 17px; }
  }
}

@media (max-width: 480px) {
  .search-hero {
    padding: 40px 12px 32px;

    h1 { font-size: 22px; line-height: 1.3; }
    p { font-size: 13px; }
  }

  .search-body { padding: 20px 12px; }
  .guide { padding: 18px 14px; }
  .result { padding: 16px 14px; }
}
</style>
